'use client';

import Link from 'next/link';
import { useLocale } from './LocaleProvider';
import { dict, t } from '@/lib/i18n';
import { SophiaLogo } from './SophiaLogo';

export function Footer() {
  const { locale } = useLocale();

  return (
    <footer className="relative border-t border-white/5 py-14 bg-ink-900">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-6">
        <div>
          <div className="flex items-center gap-2 mb-2">
            <SophiaLogo size={28} className="rounded-luxe" />
            <span className="font-serif text-lg text-fog-100">Sophia</span>
          </div>
          <p className="text-fog-500 text-sm max-w-md">{t(dict.footer.tagline, locale)}</p>
          <p className="text-fog-700 text-xs mt-2">{t(dict.footer.made, locale)}</p>
        </div>

        <div className="flex gap-6 text-sm text-fog-300">
          <Link
            href="/privacy"
            className="hover:text-fog-100 transition-colors duration-150 ease-out"
          >
            {t(dict.footer.privacy, locale)}
          </Link>
          <Link
            href="/terms"
            className="hover:text-fog-100 transition-colors duration-150 ease-out"
          >
            {t(dict.footer.terms, locale)}
          </Link>
          <a
            href="mailto:hello@mysophia.tech"
            className="hover:text-fog-100 transition-colors duration-150 ease-out"
          >
            {t(dict.footer.contact, locale)}
          </a>
        </div>
      </div>
    </footer>
  );
}
